import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from 'api/fetchApi';
import { IApiUserTradingAccountType } from 'api/interfaces/data-contracts';

export const apiMasterAccount = {
  getInitialDataList: async () => {
    return await fetchApi.get<IApiUserTradingAccountType[]>(ApiUrls.accountType.getMasterType);
  },
};
